import React from 'react';
import { Navigate } from 'react-router-dom';
import { canAccessRoute } from '../config/roles';

const RoleRoute = ({ path, roleId, children }) => {
	if (!canAccessRoute(roleId, path)) {
		return <Navigate to="/dashboard" replace />;
	}

	return children;
};

export default RoleRoute;
